export const EQPT_TYPE = [
  {
    id: "1",
    name: "노트북",
  },
  {
    id: "2",
    name: "모니터",
  },
  {
    id: "9",
    name: "기타",
  },
];

export const LOC = [
  {
    id: "A01",
    name: "A01",
  },
  {
    id: "A02",
    name: "A02",
  },
  {
    id: "A03",
    name: "A03",
  },
  {
    id: "A04",
    name: "A04",
  },
  {
    id: "B01",
    name: "B01",
  },
  {
    id: "B02",
    name: "B02",
  },
  {
    id: "B03",
    name: "B03",
  },
  {
    id: "B04",
    name: "B04",
  },
  {
    id: "C01",
    name: "C01",
  },
  {
    id: "C02",
    name: "C02",
  },
  {
    id: "D01",
    name: "D01",
  },
  {
    id: "D02",
    name: "D02",
  },
];
